import BookType from "./BookType";
import BookList from "./BookList";

const ListLayout = () => {
  return (
    <div className="order-2 xl:-order-1">
      <BookType />
      <BookList />
    </div>
  );
};

export default ListLayout;
